import spartaStoreUtility from "global/sparta-store-utility";






class SpartaRequireUtility {





  getRequirePromise(urls) {
    return new Promise((resolve, reject) => {
      this.getRequire()(urls, resolve, reject);
    });
  }


  getRequire() {
    const widgetContext = spartaStoreUtility.getData('applicationContext');

    return widgetContext
      ? window.sparta.require[widgetContext.name][widgetContext.version].require
      : window.require;
  }
}

export default new SpartaRequireUtility();